import { BsFillSuitHeartFill } from "react-icons/bs";

import "./addToFavorite.scss";
function AddToFavorite(props) {
  const { restaurant_id, isClicked, setIsClicked } = props;
  const handleClick = async (event, favorite) => {
    event.stopPropagation();
    console.log(favorite);

    console.log(isClicked);
    await fetch("https://femez.onrender.com/API/user/addFavoriteRestaurant", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      body: JSON.stringify({ restaurant_id, favorite }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.favoriteRestaurant) {
          console.log("Favorite added successfully");
          console.log(
            "Updated favoriteRestaurant array:",
            data.favoriteRestaurant
          );
          let restaurantIds = data.favoriteRestaurant.map(
            (item) => item.restaurant_id
          );
          console.log("restaurantIds", restaurantIds);
          sessionStorage.setItem(
            "favorites",
            JSON.stringify(JSON.stringify(restaurantIds))
          );
          setIsClicked(!isClicked);
        } else {
          console.log("Error:", data.message);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };
  return (
    <div>
      {" "}
      <BsFillSuitHeartFill
        onClick={(event) =>
          handleClick(
            event,
            sessionStorage.getItem("favorites") &&
              JSON.parse(sessionStorage.getItem("favorites")).includes(
                restaurant_id
              )
              ? "notFavorite"
              : "isFavorite"
          )
        }
        className={`favorite ${
          sessionStorage.getItem("favorites") &&
          JSON.parse(sessionStorage.getItem("favorites")).includes(
            restaurant_id
          )
            ? "clicked"
            : ""
        }`}
      />
    </div>
  );
}

export default AddToFavorite;
